<img [src]="'images/icons/' + name + '.svg'" [alt]="alt" [width]="width" [height]="height" [pTooltip]="tooltip" tooltipPosition="top">

